import React from "react"
import GenderStyle from "./GenderStyle.module.css"
import translate, { keys } from "../../../../../translation/translator"

const Gender = ({ gender, handleChangeGender, locale }) => {
  return (
    <div className={GenderStyle.holder}>
      <p className={GenderStyle.title}>
        2. {translate(keys.WHAT_IS_YOUR_GENDER, locale)}
      </p>
      <div className={GenderStyle.units}>
        <label
          htmlFor="male"
          className={
            gender === "Male"
              ? GenderStyle.active_unit
              : GenderStyle.unit_holder
          }
        >
          <input
            id="male"
            type="radio"
            value="Male"
            checked={gender === "Male"}
            onChange={handleChangeGender}
          />
          {translate(keys.MALE, locale)}{" "}
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fal"
            data-icon="mars"
            className="svg-inline--fa fa-mars fa-w-12"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 384 512"
          >
            <path
              fill="currentColor"
              d="M372 64h-88c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h45.4l-95.5 95.5C209.2 171.8 178 160 144 160 64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-34-11.8-65.2-31.5-89.9l95.5-95.5V164c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12zM144 416c-61.9 0-112-50-112-112 0-61.9 50-112 112-112 61.9 0 112 50 112 112 0 61.9-50 112-112 112z"
            />
          </svg>
        </label>
        <label
          htmlFor="female"
          className={
            gender === "Female"
              ? GenderStyle.active_unit
              : GenderStyle.unit_holder
          }
        >
          <input
            id="female"
            type="radio"
            value="Female"
            checked={gender === "Female"}
            onChange={handleChangeGender}
          />
          {translate(keys.FEMALE, locale)}
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fal"
            data-icon="venus"
            className="svg-inline--fa fa-venus fa-w-9"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 288 512"
            width="15"
          >
            <path
              fill="currentColor"
              d="M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 74.1 56 135.2 128 143.1V384H76c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h52v52c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12v-52h52c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12h-52v-64.9c72-7.9 128-69 128-143.1zm-256 0c0-61.9 50-112 112-112 61.9 0 112 50 112 112 0 61.9-50 112-112 112-61.9 0-112-50-112-112z"
            />
          </svg>
        </label>
      </div>
    </div>
  )
}

export default Gender
